export default "__VITE_ASSET__DxgJHNbr__"